export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__TRANSCRIPT': 'Transcript',
    '__CALL_TRANSCRIPT': 'Call Transcript'
};
